module.exports = __webpack_public_path__ + "img/illuminatingBIM_checked.ca4b1f3a.png";